export function LocationMap() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-8">
      <div className="w-full">
        <iframe
          src="https://maps.google.com/maps?width=100%25&amp;height=500&amp;hl=en&amp;q=32.987981,-82.3851895+(Watson%20Aero%20LLC)&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          width="100%"
          height="500"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Watson Aero LLC Location at Louisville Municipal Airport"
        />
      </div>
    </section>
  );
}